module.exports = __webpack_public_path__ + "img/6.740100f3.png";